module.exports = __webpack_public_path__ + "static/img/yt.2baed351.png";